import { makeEduConfig } from './baseConfig.js';

const CONFIG = makeEduConfig();
CONFIG.sections = CONFIG.sections.filter(({ key }) => key !== 'documents');

export default CONFIG;
